/**
 * @ Author: Zhang Yujun
 * @ Create Time: 2025-01-22 12:10:02
 * @ Modified by: Zhang Yujun
 * @ Modified time: 2025-02-18 08:54:31
 * @ Description:
 */

const dev = {
  API_URL: 'http://113.108.110.30:29000/qgsp-api/',
  RESOURCE_PATH: 'http://113.108.110.30:29000/qgsp-res/',
  DEFAULT_AVATAR_URL:
    'http://113.108.110.30:29000/qgsp-res/image/default-avatar/',
  APP_CODE: 'VxDNI1PG',
  PAY_TEST: true
}

// const prod = {
//   API_URL: 'http://113.108.110.30:29000/qgsp-api/',
//   RESOURCE_PATH: 'http://113.108.110.30:29000/qgsp-res/',
//   DEFAULT_AVATAR_URL:
//     'http://113.108.110.30:29000/qgsp-res/image/default-avatar/',
//   APP_CODE: 'VxDNI1PG',
//   PAY_TEST: true
// }
const prod = {
  API_URL: 'https://www.lutonghd.com/qgsp-api/',
  RESOURCE_PATH: 'https://www.lutonghd.com/qgsp-res/',
  DEFAULT_AVATAR_URL: 'https://www.lutonghd.com/qgsp-res/image/default-avatar/',
  APP_CODE: 'eBvRKSO8',
  PAY_TEST: false
}

const CONFIG = {
  PRODUCT_ID: 'qgsp',
  // 版本号
  VERSION: '2.10.00',
  VERSION_CODE: 21000,
  // 渠道
  CHANNEL_CODE: 'pc',
  PAY_CHANNEL_TYPE_WX: 'weixin',
  PAY_CHANNEL_TYPE_ZFB: 'zhifubao',
  // 工商电子标识地址
  GOV_ICONS_URL: 'https://gswj.ebs.org.cn/js/govicons/index.js?entId=1887070921477627906&width=80&height=40&imgType=2'
}

// export default dev;
export default Object.assign(
  CONFIG,
  process.env.VUE_APP_API === 'development' ? dev : prod
)
